export const ALERT_BASIC_SET = "ALERT_BASIC_SET";
export const ALERT_BASIC_REQUEST = "ALERT_BASIC_REQUEST";
